import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import { ReleaseNoteListItem, getPlatformLabel } from '@features/components/ReleaseNotes';
import { ReleaseNote } from '@/api/apis/release-notes';
import { onActivateKeyDown } from '@/utils/helpers';

type ReleaseNotePlatformGroupProps = {
  platform: string;
  releases: ReleaseNote[];
  isExpanded: boolean;
  isEditMode: boolean;
  selectedReleaseId: string | null;
  onToggle: (platform: string) => void;
  onSelect: (releaseId: string) => void;
  onEdit: (release: ReleaseNote) => void;
  onDelete: (release: ReleaseNote) => Promise<boolean>;
};

export const ReleaseNotePlatformGroup = ({
  platform,
  releases,
  isExpanded,
  isEditMode,
  selectedReleaseId,
  onToggle,
  onSelect,
  onEdit,
  onDelete,
}: ReleaseNotePlatformGroupProps) => (
  <div className="mb-2">
    <div
      role="button"
      tabIndex={0}
      aria-label={`Toggle ${getPlatformLabel(platform)} releases`}
      aria-expanded={isExpanded}
      onClick={() => onToggle(platform)}
      onKeyDown={onActivateKeyDown(() => onToggle(platform))}
      className="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-base-80 text-base-5 font-medium"
    >
      {isExpanded ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
      <span>{getPlatformLabel(platform)}</span>
      <span className="text-xs text-base-30 ml-auto">{releases.length}</span>
    </div>
    {isExpanded && (
      <div className="space-y-1">
        {releases.map((release, index) => (
          <ReleaseNoteListItem
            key={release.id}
            release={release}
            isCurrent={index === 0}
            isSelected={selectedReleaseId === release.id}
            onSelect={onSelect}
            onEdit={isEditMode ? onEdit : undefined}
            onDelete={isEditMode ? onDelete : undefined}
          />
        ))}
      </div>
    )}
  </div>
);
